<button class="action" [ngClass]="{'locked': conflict}" [routerLink]="link">
    <div class="action-media">
        <ng-content class="action-media-object"></ng-content>
    </div>
    @if (title) {
        <div class="action-modal">
            <div class="action-modal-window">
                <div class="action-modal-window-content">
                    {{ title  | translate }}
                </div>
            </div>
        </div>
    }
</button>
